<script lang="ts" setup>
type Reference = {
  __typename?: 'Reference';
  Components?: Maybe<Array<Maybe<ReferenceComponentsDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  external_link?: Maybe<Scalars['String']>;
  footer?: Maybe<ComponentBlockFooter>;
  locale?: Maybe<Scalars['String']>;
  localizations?: Maybe<ReferenceRelationResponseCollection>;
  name: Scalars['String'];
  priority: Scalars['Int'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  referenceTeaserCta?: Maybe<ComponentBlockReferenceTeaserCta>;
  reference_categories?: Maybe<ReferenceCategoryRelationResponseCollection>;
  seo?: Maybe<ComponentSharedSeo>;
  slug: Scalars['String'];
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
}
const props = defineProps<Reference>();
const categories = computed(() => {
  return props.reference_categories?.data;
});
const externalLink = computed(() => {
  return props.external_link;
});
setSeo(props.seo, props.localizations, "article");
</script>
<i18n lang="json">
{
  "de": {
    "blog": {
      "author": "Autor",
      "published": "Veröffentlicht",
      "topic": "Thema"
    }
  }
}
</i18n>
<template>
  <div>
    <BlockHeaderReferenceDetail
      :categories="categories"
      :headline="props.title"
      :external-link="externalLink"
    />
    <BlockRenderer
      v-for="(block, index) in props.Components"
      v-bind="block"
      :key="`${block?.__typename}-${index}`"
      class="first:mt-0"
    />
    <BlockReferenceTeaserCta
      v-if="props.referenceTeaserCta"
      :image="props.referenceTeaserCta.image"
      :reference="props.referenceTeaserCta.reference"
      :headline="props.referenceTeaserCta.headline"
      :page="props.referenceTeaserCta.page"
    />
  </div>
</template>
